import { Component, OnInit, HostBinding, Input,ChangeDetectionStrategy,ChangeDetectorRef } from '@angular/core';
import { IndexedDBService } from "../indexed-db-service/indexed-db.service";
import { EventLogModel } from "./eventlog-model";
import { EventService } from "./event.service";
import * as moment from 'moment';
import { ApplicationService } from "../application-service/application.service";
import { OxeModelService } from "../oxe-model-service/oxe-model.service";


@Component({
    selector: 'config-eventlogs',
    templateUrl: 'config-eventlogs.component.html',
    styleUrls: ['eventlogNotify.css'],
    changeDetection:ChangeDetectionStrategy.Default
})

export class ConfigEventlogsComponent implements OnInit {
    @HostBinding() class = 'home-box home-box--gutter-left flex-item-fluid flex-container-v nowrap mw35 vertical-rhythm mam ml0';
    log: Array<EventLogModel> = [];
    displayLog: Array<EventLogModel> = [];
    isAllClassVisible: boolean = false;
    isErrClassVisible: boolean = false;
    isInfoClassVisible: boolean = false;
    isExpClassVisible: boolean = false;
    isClearClassVisible: boolean = false;
    oxeVersion: string;

    constructor(
        private _indexDbService: IndexedDBService,
        public _application: ApplicationService,
        private _eventService: EventService,
        private _oxeModelService: OxeModelService,
        private cd: ChangeDetectorRef
    ) {

    }

    ngOnInit() {
        this._oxeModelService.getVersion()
            .subscribe((data) => {
                this.oxeVersion = data.toString();
            })

        this.displayLog = this._indexDbService.resultArray.filter(errorLog => errorLog.type === 'Error');
        if (this.displayLog.length === 0) {
            this.btnAllClicked();
        } else if (this.displayLog.length != 0) {
            this.isErrClassVisible = true;
            this.isAllClassVisible = false;
            this.isInfoClassVisible = false;
            this.isExpClassVisible = false;
            this.isClearClassVisible = false;
        }

    }

    btnErrorClicked() {
        this.isErrClassVisible = true;
        this.isAllClassVisible = false;
        this.isInfoClassVisible = false;
        this.isExpClassVisible = false;
        this.isClearClassVisible = false;
        this.displayLog = this._indexDbService.resultArray.filter(errorLog => errorLog.type === 'Error');

    }
    btnInfoClicked() {
        this.isInfoClassVisible = true;
        this.isAllClassVisible = false;
        this.isErrClassVisible = false;
        this.isExpClassVisible = false;
        this.isClearClassVisible = false;
        this.displayLog = this._indexDbService.resultArray.filter(errorLog => errorLog.type === 'Info');

    }

    btnClearClicked() {
        this.isClearClassVisible = false;
        this.isInfoClassVisible = false;
        this.isAllClassVisible = false;
        this.isErrClassVisible = false;
        this.isExpClassVisible = false;
        this._indexDbService.resultArray = [];
        this.btnAllClicked();
        this.cd.markForCheck();
    }


    btnAllClicked() {
        this.isAllClassVisible = true;
        this.isInfoClassVisible = false;
        this.isErrClassVisible = false;
        this.isExpClassVisible = false;
        this.isClearClassVisible = false;
        this.displayLog = this._indexDbService.resultArray.filter(errorLog => errorLog.type != 'Log');

    }

    public get events(): Array<Object> {
        //return "Hellooooooooooooooooooooooo";

        return this.log;
    }

    btnExport() {
        this.isExpClassVisible = true;
        this.isAllClassVisible = false;
        this.isErrClassVisible = false;
        this.isInfoClassVisible = false;
        this.onExport();
    }

    isExportEnabled(): boolean {
        if (this.displayLog.length > 0)
            return true;
        else
            return false;
    }
    onExport() {
        let logs: Array<any> = [];
        let sortedLogs: Array<string> = this._indexDbService.resultArray.sort((a, b) => a['date'].toJSON().localeCompare(b['date'].toJSON()))
            .map((log: Object) =>
                moment(log['date']).format('DD/MM/YY') + '\t' + moment(log['date']).format('HH:mm:ss') + '\t' + log['type'] + '\t' + log['message'] + '\n'
            );
        sortedLogs.unshift("WBM-VERSION : V" + this._application.version + '\t\n');
        sortedLogs.unshift("OXE Version : V" + this.oxeVersion + '\t');
        let blobObject = new Blob([sortedLogs.join('\t')], {
            type: 'text/plain'
        });

        let fileName = 'OXE-WBM-' + moment().format('DD-MM-YYYY--H-mm-ss') + '.txt';
        let url = window.URL.createObjectURL(blobObject);

        let e = document.createElement('a');
        e.setAttribute('href', url);
        e.setAttribute('download', fileName);
        document.body.appendChild(e);
        e.click();
        document.body.removeChild(e);
    }

    onCloseLog() {
        this._eventService.errorLogLength = 0;
        this._eventService.enableEventDisplay(false);
    }
}